<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }" ref="validationObserver3">
  
    <Error_messages :error_message="messages.error" :success_message = "messages.success"/>

      <form @submit.prevent="handleSubmit(Change_Password)" ref="form3">

        <ValidationProvider name="password" :rules="rules.password" v-slot="{passed, failed, failedRules, errors}">

          <b-form-group label="Password " label-for="password">
              <b-form-input id="password" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"     
                type="password" placeholder="Enter your Password..." v-model="form.password"></b-form-input>
                <div v-if="errors.length" class="invalid-feedback"> {{ failed && validation_messages.password ? validation_messages.password[Object.keys(failedRules)[0]] : errors[0] }} </div>

          </b-form-group>
        </ValidationProvider>

        <ValidationProvider name="password_confirmation" :rules="rules.password_confirmation" v-slot="{passed, failed, failedRules, errors}">
          <b-form-group label="Password confirm " label-for="passwordConfirm">
              <b-form-input id="passwordConfirm" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"     
                type="password" placeholder="Enter your Password..." v-model="form.password_confirmation"></b-form-input>
                <div v-if="errors.length" class="invalid-feedback"> {{ failed && validation_messages.password_confirmation ? validation_messages.password_confirmation[Object.keys(failedRules)[0]] : errors[0] }} </div>
          </b-form-group>
        </ValidationProvider>

      
        <b-spinner v-if="loading" variant="primary" class="float-right" label="Spinning"></b-spinner>
        <button v-else type="submit" class="btn btn-primary float-right">Submit</button>

      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { getAccessToken } from "@/Utils/authentication";
import axios from "axios";
import { API_URL } from "../../../config/config";
import Error_messages from "@/helpers/error_messages.vue";
import { core } from '@/config/pluginInit';
export default {
  name:'writeNewPassword',
  components: {Error_messages},
  data() {
    return {
      loading: false,
      messages: { error: "", success: "" },
      userId:'',
      form: {
        password: '',
        password_confirmation: '',
      },
      rules: {
        password: 'required|min:8',
        password_confirmation: 'required|confirmed:password'
      },
      validation_messages: {
        password: {
          required: 'Password is required',
          min: 'Password must be at least 8 characters long',
        },
        password_confirmation: {
          required: 'Password confirmation is required',
          confirmed: 'Password confirmation does not match',
        },
      },
      
    }
  },

  // get user id from url
mounted() {
  const accessToken = getAccessToken();
  if(accessToken){
    axios.get(`${API_URL}users/info`, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',  
      }
    }).then(response => {
      
      this.userId = response.data.id;
      this.$store.commit('User/setUser', response.data);
    })
  }
  core.index();
 
},
  methods: {
    async Change_Password() {
      this.loading = true;
      const accessToken = getAccessToken();
      const apiEndpoint = `${API_URL}users/${this.userId}`;
      const dataPayload = this.form;
      const config = {
        headers: {
          'Authorization': `Bearer ${accessToken}`, 
          'Content-Type': 'application/json',      
        },
      };

      axios.post(apiEndpoint, dataPayload, config)
        .then(response => {
          this.messages.error="";
          this.loading = false;
          window.location.href = '/';
        })
        .catch(error => {
          if (error.response) {
            this.messages.error = error.response.data.message;
            this.loading = false;
          } else {
            this.messages.error = error.message;
            this.loading = false;
          }
        });
      },
  },
}
</script>

<style scoped>

</style>
